module.exports = __webpack_public_path__ + "static/subset-UniNeueRegular-Italic-2cd2dcc48a0a6ef1b1bb987c7d5185a0.woff2";